import { usePbProps } from '@content/helpers/src/context.tsx'
import ProductCard from '../productCard/ProductCard'
import CarouselWrapper from '@commons/carousel-wrapper/CarouselWrapper'
import { forwardRef } from 'react'

const ProductsSlider = forwardRef(({ activeCategoryData }, ref) => {
    const { modalId }: any = usePbProps()

    if (activeCategoryData) {
        return (
            <CarouselWrapper
                ref={ref}
                carouselOptions={{
                    navPosition: 'top',
                    'data-slides': activeCategoryData.length
                }}
                carouselItemOptions={{}}
                items={activeCategoryData?.items?.map((item, index) => (
                    <ProductCard index={index} card={item} modalId={modalId} />
                ))}
            />
        )
    }
})

export default ProductsSlider
